<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon @click="editRecord" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
    <feather-icon @click="confirmDeleteRecord" icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
  </div>
</template>

<script>
import axios from 'axios'

export default {
  methods: {
    editRecord () {
      this.$router.push(`/a/labs/pools/${this.params.data.id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Please confirm you want to delete this pool.',
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      this.$vs.loading()

      axios
        .delete(`${process.env.VUE_APP_ROOT_LABS_API}/labs/pools/${this.params.data.id}`)
        .then((response) => {
          this.$vs.loading.close()
          if (response.status === 200) {
            this.params.loadProductBuffer()

            return this.$vs.notify({
              color: 'success',
              title: 'Pool Deleted',
              text: 'You have successfully deleted the pool',
              position: 'top-right'
            })
          }

          this.showError({ response })
        })
        .catch(this.showError)
    },
    showError (exception) {
      this.$vs.loading.close()
      return this.$vs.notify({
        title: 'Failed to delete pool',
        text: 'We dont know why that happened sorry',
        color: 'danger',
        position: 'top-right'
      })
    }
  }
}
</script>
